module.exports = __webpack_public_path__ + "static/card-lowenthal-e551a25ee94a374b9e449484ac430b7e.jpg";